import { graphql, useLazyLoadQuery } from "react-relay"
import { useIsFeatureEnabledQuery } from "@/hooks/__generated__/useIsFeatureEnabledQuery.graphql"
import { FeatureFlagType } from "@/types/__generated__/union-types"

const featureFlagQuery = graphql`
  query useIsFeatureEnabledQuery($flags: [FeatureFlagType!]!) {
    featureFlags(featureFlags: $flags) {
      featureFlag
      isEnabled
    }
  }
`

export const useIsFeatureEnabled = (flag: FeatureFlagType) => {
  const featureFlags = useLazyLoadQuery<useIsFeatureEnabledQuery>(featureFlagQuery, { flags: [flag] })

  return featureFlags.featureFlags.some((f) => f.featureFlag === flag && f.isEnabled)
}
